<template>
  <div>
    <el-table :data="orderDeatilsData.itemList" tooltip-effect="light">
      <el-table-column label="项目/产品/套餐" min-width="115px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.isGift===1" effect="light" placement="bottom">
            <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
            <span class="give-icon">赠</span>
          </el-tooltip>
          <el-tooltip v-if="scope.row.isGift===2" effect="light" placement="bottom">
            <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
            <span class="buygive-icon">买赠</span>
          </el-tooltip>
          <el-tooltip v-if="scope.row.isGift===3" effect="light" placement="bottom">
            <div slot="content">到期时间：{{ scope.row.expireTime }}</div>
            <span class="fullgive-icon">满赠</span>
          </el-tooltip>
          <span :class="scope.row.itemType==0 ? 'project-icon' : scope.row.itemType==1 ? 'product-icon' : 'package-icon'">{{ scope.row.itemType==0 ? '项目' : scope.row.itemType==1 ? '产品' : '套餐' }}</span>
          <span>{{ scope.row.name || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="原价（元）" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.price }}</span>
          <el-tooltip v-if="scope.row.isUpdatePrice == 1" effect="light" placement="right">
            <div slot="content">已改价</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="折后价（元）" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span v-if="scope.row.isGift===1 || scope.row.isGift===2 || scope.row.isGift===3">0.00</span>
          <div v-else>
            <div v-if="orderDeatilsData.memberMsg ? (orderDeatilsData.memberMsg.wholesaleInfo && scope.row.isWholesale == 1) ? true : false : false" style="height: 28px;line-height: 28px;">
              <span style="float: left;line-height: 28px;">{{ scope.row.discountMoney ? (scope.row.discountMoney*1).toFixed(2) : (scope.row.price*scope.row.discount/10).toFixed(2) }}</span>
              <el-popover placement="right" trigger="hover">
                <div style="padding: 10px;font-size: 12px;">{{ orderDeatilsData.memberMsg ? orderDeatilsData.memberMsg.wholesaleInfo ? orderDeatilsData.memberMsg.wholesaleInfo.gradeName : '' : '' }}</div>
                <img slot="reference" style="width: 28px;height: 28px;margin-left: 5px;" src="@/assets/images/goods.png" />
              </el-popover>
            </div>
            <span v-else>{{ scope.row.discountMoney ? scope.row.discountMoney==='0.00'? (scope.row.price*scope.row.discount/10).toFixed(2) :(scope.row.discountMoney*1).toFixed(2) : (scope.row.price*scope.row.discount/10).toFixed(2) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="count" label="数量" :show-overflow-tooltip="true">
      </el-table-column>
      <!-- <el-table-column label="小计" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div v-if="orderDeatilsData.bookOrderMsgDTO">0.00</div>
          <div v-if="scope.row.isGift===1">0.00</div>
          <div v-else>
            <span v-if="scope.row.isGiftDeduct===1">0.00</span>
            <span v-else>{{ (scope.row.deductAmount == 0 || !scope.row.deductAmount) ? scope.row.resultPrice : (scope.row.resultPrice*1-scope.row.deductAmount*1).toFixed(2) }}</span>
          </div>
        </template>
      </el-table-column> -->

      <el-table-column label="小计" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div v-if="scope.row.isGift===1">0.00</div>
          <div v-else>
            <div v-if="orderDeatilsData.bookOrderMsgDTO==null&&orderDeatilsData.orderType===6">0.00</div>
            <span v-if="scope.row.isGiftDeduct===1">0.00</span>
            <span v-else>{{ (scope.row.deductAmount == 0 || !scope.row.deductAmount) ? scope.row.resultPrice : (scope.row.resultPrice*1-scope.row.deductAmount*1).toFixed(2) }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="优惠金额（元）" width="120px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div v-if="scope.row.isGift">--</div>
          <div v-else>
            <!-- (scope.row.totalDiscountPrice==0?false:true) -->
            <span>{{ scope.row.totalDiscountPrice }}</span><el-tooltip v-if="(scope.row.deductDtoList ? scope.row.deductDtoList.length > 0&&scope.row.totalDiscountPrice!=0 ? true : false : false) || (scope.row.detailList ? scope.row.detailList.length > 0&&scope.row.totalDiscountPrice!=0 ? true : false : false)" effect="light" placement="right">
              <div slot="content">
                <h5 v-for="(v,n) in scope.row.deductDtoList" :key="n">{{ v.isElectronicTicketDeduct == 1 ? '电子票划扣：-￥' : v.isGiftDeduct == 1 ? '赠品划扣：-￥' : '套餐划扣：-￥' }}{{ v.deductAmount }}</h5>
                <h5 v-for="(v,n) in scope.row.detailList" v-show="v.type != 1 && v.type != 99" :key="n">{{ v.type == 2 ? '特价活动：-￥' : v.type == 3 ? '定时打折：-￥' : v.type == 4 ? '会员优惠：-￥' : v.type == 5 ? '改价优惠：-￥' : '' }}{{ ((scope.row.price*1-v.rightsPrice*1)*v.count).toFixed(2) }}</h5>
              </div>
              <i class="iconfont" style="font-size: 14px;color:#d3d3d3;margin-left: 5px;">&#xe71a;</i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="提成员工" min-width="95px">
        <template slot-scope="scope">
          <div v-if="scope.row.isGift">--</div>
          <div v-else>
            <el-tooltip v-if="scope.row.percentage4ServeList.length > 0 && scope.row.itemType == 0" class="item" effect="light" placement="right">
              <div slot="content" style="display: flex;">
                <p>{{ Lib.collectively() }}：</p>
                <div style="flex: 1;">
                  <p v-for="(item,index) in scope.row.percentage4ServeList" :key="index" style="padding: 0 10px 0 0;">
                    <span>{{ item.isGuest == 1 ?'点客':'非点客' }}-{{ item.technicianName }}<br></span>
                  </p>
                </div>
              </div>
              <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                <span>{{ Lib.collectively() }}：</span>
                <span v-for="(a,b) in scope.row.percentage4ServeList" :key="b">{{ a.isGuest == 1 ?'点客':'非点客' }}-{{ a.technicianName }}{{ scope.row.percentage4ServeList.length == (b+1) ? '' : ',' }}</span>
              </p>
            </el-tooltip>
            <div v-if="scope.row.percentage4ServeList.length == 0 && scope.row.itemType == 0">--</div>
            <!-- <span v-else-if="scope.row.percentage4ServeList.length == 0 && scope.row.percentageSellServeList.length == 0 && scope.row.itemType == 0">--</span> -->
            <div v-if="scope.row.percentageSellServeList||scope.row.refundType != 1&&scope.row.refundType !=null">
              <el-tooltip v-if="scope.row.percentageSellServeList.length > 0" class="item" effect="light" placement="right">
                <div slot="content" style="display: flex;">
                  <p>销售：</p>
                  <div style="flex: 1;">
                    <p v-for="(item,index) in scope.row.percentageSellServeList" :key="index" style="padding: 0 10px 0 0;">
                      <span>{{ item.technicianName||'--' }}<br></span>
                    </p>
                  </div>
                </div>
                <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                  <span>销售：</span>
                  <span v-for="(c,d) in scope.row.percentageSellServeList" :key="d">{{ c.technicianName }}{{ scope.row.percentageSellServeList.length == (d+1) ? '' : ',' }}</span>
                </p>
              </el-tooltip>
              <el-tooltip v-if="scope.row.percentageSellServeList.length == 0 && scope.row.itemType != 0" :disabled="orderDeatilsData.orderType == 3 ? (orderDeatilsData.percentageTechnicianName ? false : true) : (scope.row.percentageTechnicianName ? false : true)" class="item" effect="light" placement="right">
                <div slot="content" style="display: flex;">
                  <p>{{ orderDeatilsData.orderType == 3 ? (orderDeatilsData.percentageTechnicianName ? ('销售：'+orderDeatilsData.percentageTechnicianName) : '--') : (scope.row.percentageTechnicianName ? ('销售：'+scope.row.percentageTechnicianName) : '--') }}</p>
                </div>
                <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                  <span>{{ orderDeatilsData.orderType == 3 ? (orderDeatilsData.percentageTechnicianName ? ('销售：'+orderDeatilsData.percentageTechnicianName) : '--') : (scope.row.percentageTechnicianName ? ('销售：'+scope.row.percentageTechnicianName) : '--') }}</span>
                </p>
              </el-tooltip>
              <div v-if="scope.row.itemType == 0&&scope.row.percentageSellServeList.length !== 0 ">--</div>
            </div>
            <div v-else>--</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="orderDeatilsData.orderType != 3 && orderDeatilsData.refundStatus" label="退款类型" width="120px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <!-- 0:退金额,1:退次数,2:退货,3:退金额退货,4:退次数退货 -->
          <span v-if="scope.row.isGift">--</span>
          <span v-else>{{ scope.row.refundType === null ? '--' : scope.row.refundType == 1 ? '退次数' : scope.row.refundType == 2 ? '退货' : scope.row.refundType == 3 ? '退金额退货' : scope.row.refundType == 4 ? '退次数退货' : '退金额' }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

export default {
  props: {
    orderDeatilsData: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
    };
  },
  activated() {
  },
  methods: {
  }
};
</script>
<style lang="less" scoped>
</style>
